export type Deferred = Promise<unknown> & { resolve: (msg?: unknown) => unknown; reject: (error: unknown) => void };

// Creates promise that could be resolved/rejected from outside, as it has
// `resolve`/`reject` functions exposed as public properties
// TODO Cover with unit tests, it may not work at all
export function createDeferred() {
  let promiseResolve: (msg?: unknown) => unknown;
  let promiseReject: (error: unknown) => void;

  const promise = new Promise<unknown>((resolve, reject) => {
    promiseResolve = resolve;
    promiseReject = reject;
  }) as Deferred;

  // @ts-expect-error TODO Fix
  promise.resolve = promiseResolve;
  // @ts-expect-error TODO Fix
  promise.reject = promiseReject;

  return promise;
}
